'use strict';

import { graphql, useStaticQuery } from 'gatsby';

function useSiteMetadata() {
	const data = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					author
					config {
						allergy_checks_groups
						allergy_tests_groups
						business_tests_groups
						campaign_end_time
						campaign_start_time
						campaign_image
						campaign_discount_amount
						campaign_discount_code
						campaigns
						gift_card_template_id
						health_checks_groups
						ignore_allergy_groups
						support_business_groups
						support_index_groups
						support_product_groups {
							blood_sample
							ecg
							mri
						}
					}
					description
					siteUrl
					supportEmail
					supportPhoneNumber
					title
					zample_app_id
					zample_app_url
				}
			}
		}
	`);

	return data.site.siteMetadata;
}

export default useSiteMetadata;
